var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 59.88a40.64 40.64 0 0 1 40.63 40.62c0 5.28-1.06 10.24-2.93 14.87l23.73 23.72a96.02 96.02 0 0 0 27.86-38.59c-14.05-35.67-48.75-60.94-89.37-60.94a94.62 94.62 0 0 0-32.34 5.69L85.63 62.8a39.43 39.43 0 0 1 14.87-2.92ZM19.25 37.69l18.52 18.53 3.74 3.74a95.9 95.9 0 0 0-30.38 40.54c14.05 35.67 48.74 60.94 89.37 60.94 12.6 0 24.62-2.44 35.59-6.83l3.41 3.41 23.8 23.73 10.32-10.32L29.57 27.37 19.25 37.7Zm44.93 44.94 12.6 12.59c-.41 1.7-.66 3.5-.66 5.28a24.34 24.34 0 0 0 24.38 24.38c1.79 0 3.58-.25 5.28-.66l12.6 12.6a40.27 40.27 0 0 1-17.88 4.3 40.64 40.64 0 0 1-40.63-40.62c0-6.42 1.63-12.43 4.31-17.88Zm35.02-6.34 25.6 25.6.16-1.3a24.34 24.34 0 0 0-24.38-24.38l-1.38.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "assets/media/eye-off.ff54dc22.svg";
export { ForwardRef as ReactComponent };